exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__preferences___1GgfM{margin:0;padding:0;border:1px solid #dbdbdc}.style__preferences___1GgfM li{display:inline-block;padding:10px 20px;list-style:none;cursor:pointer}.style__preferences___1GgfM li:not(:last-of-type){border-right:1px solid #dbdbdc}.style__preferences___1GgfM .style__active___2L4F1{background:#f8d0ca}", ""]);

// exports
exports.locals = {
	"preferences": "style__preferences___1GgfM",
	"active": "style__active___2L4F1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/preferences-modal/style.css
// module id = 706
// module chunks = 0